var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    d: "M6.515 11.125c.006-.832.076-1.407.21-1.723.133-.317.491-.737 1.073-1.262.564-.667.966-1.18 1.206-1.539.24-.36.359-.792.359-1.3 0-.604-.161-1.069-.483-1.394-.322-.325-.783-.487-1.382-.487-.518 0-.959.14-1.32.423-.363.282-.544.697-.544 1.244H4.026l-.025-.051c-.017-.918.305-1.653.966-2.206C5.628 2.277 6.472 2 7.498 2c1.124 0 1.996.286 2.617.86.622.572.933 1.372.933 2.398 0 .736-.201 1.409-.603 2.019-.402.61-.934 1.234-1.595 1.873-.302.307-.486.584-.552.83-.065.244-.098.626-.098 1.145H6.515zm1.736 3.507H6.498v-1.78H8.25v1.78z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.da0247e79a0a41300a1a2cde628a7d80.svg";
export { ForwardRef as ReactComponent };